import { mapValues } from '@lodash';

export function isPeselValid(value: string): boolean {
    if (!value || value.length !== 11) {
        return false;
    }

    const multipliers = [9, 1, 3, 7];
    let sum = 0;

    for (let i = 0; i < value.length - 1; i += 1) {
        sum += Number(value[i]) * multipliers[(i + 1) % 4];
    }

    const calculatedCheckDigit = sum % 10;
    const actualCheckDigit = Number(value.charAt(value.length - 1));

    if ((calculatedCheckDigit === 0 && actualCheckDigit === 0)
        || actualCheckDigit === 10 - calculatedCheckDigit) {
        return true;
    }

    return false;
}

export function isIbanValid(value: string): boolean {
    if (!value) {
        return false;
    }

    let iban = value.replace(/\s/g, '');

    if (iban.length !== 28) {
        return false;
    }

    if (!iban.match(/^[\dA-Z]+$/)) {
        return false;
    }

    const len = iban.length;
    iban = iban.substr(4) + iban.substr(0, 4);

    let s: string = '';

    for (let i = 0; i < len; i += 1) {
        s += parseInt(iban.charAt(i), 36);
    }

    let m = <any>s.substr(0, 15) % 97;
    for (s = s.substr(15); s; s = s.substr(13)) {
        m = <any>(m + s.substr(0, 13)) % 97;
    }

    return m === 1;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/core/validation/index.ts